<template lang="pug">
    layout(:page="'auth'")
        template(slot="title")

            // Title
            title-component(:title="$t('auth.login.title')" type="h1")

            // Message
            div(v-html="$t('auth.login.message')")

        // Login form
        login-form
</template>

<script>
    import LoginForm from './LoginForm';
    import Layout from '../Layout';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';

    export default {
        components: {
            LoginForm,
            Layout,
            TitleComponent: Title,
            SeparatorComponent: Separator
        },
        props: {
            email: VueTypes.string.def(''),
            password: VueTypes.string.def('')
        },
        created() {
            if (this.email && this.password) {
                const params = {
                    email: this.email,
                    password: this.password
                };

                this.login(params);
            }
        },
        methods: {
            ...mapActions('auth', ['login'])
        }
    };
</script>
